import { getCompanyQueues } from 'adminPanel/api/companies';
import { Queue } from 'adminPanel/types';
import { useEffect, useState } from 'react';

export const useCompanyQueues = (companyId: number) => {
    const [queues, setQueues] = useState<Queue[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getCompanyQueues(companyId)
            .then(setQueues)
            .finally(() => {
                setIsLoading(false);
            });
    }, [companyId]);

    return { queues, isLoading };
};
